<template>
  <div class="creditForm">
    <el-form :model="credit_form_data"
             label-position="top"
             status-icon
             ref="creditForm"
             :rules="creditRules"
             :show-message="false">
      <div class="card_img">
        <img src="../assets/billing/visa-color_large@2x(1).png" alt="">
        <img src="../assets/billing/mastercard-color@2x(1).png" alt="">
        <img src="../assets/billing/americanexpress-color@2x(1).png" alt="">
        <img src="../assets/billing/discover-color@2x(1).png" alt="">
        <img src="../assets/billing/mastercard-color@2x(1).png" alt="">
      </div>
      <el-form-item label="Card Number" label-width="120px" required prop="card_number">
        <el-input :rows="2" placeholder="Card number" v-model="credit_form_data.card_number" @blur="blurCardNumHandle">
        </el-input>
      </el-form-item>
      <el-form-item label="Expiration Date" label-width="120px" required>
          <div style="display: flex">
            <div style="display: flex;margin-right: 16px">
              <div class="data_title" style="width: 46px">Month</div>
              <div style="flex: 1">
                <el-form-item prop="expiry_date_month" required>
                  <el-select v-model="credit_form_data.expiry_date_month" placeholder="MM">
                    <el-option
                      v-for="item in month_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div style="display: flex">
              <div class="data_title" style="width: 33px">Year</div>
              <div style="flex: 1" class="year">
                <el-form-item prop="expiry_date_year" required>
                  <el-select v-model="credit_form_data.expiry_date_year" placeholder="YYYY">
                    <el-option
                      v-for="item in year_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
      </el-form-item>
      <el-form-item label="Card Holder Name" label-width="120px" required prop="card_holder_name">
        <el-input
          :rows="2"
          placeholder="Card holder name"
          v-model="credit_form_data.card_holder_name">
        </el-input>
      </el-form-item>
      <el-form-item label="CCV" label-width="120px" required prop="cvv">
        <el-input
          :rows="2"
          placeholder="CCV"
          v-model="credit_form_data.cvv"
          @blur="creditCvvHandle"
        >
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "creditPayform",
  created() {
   this.year_options = this.getYearsArray()
  },
  data(){
    return{
      credit_form_data:{
        card_holder_name:"",
        card_number:'',
        expiry_date_year:'',
        expiry_date_month:"",
        cvv:'',
      },
      creditRules:{
        card_holder_name:[
          { required: true, message: '', trigger: 'blur' }
        ],
        card_number:[
          { required: true, message: '', trigger: 'blur' },
          { min: 16,max:16,required: true, message: '', trigger: ['blur', 'change'] }
        ],
        expiry_date_year:[
          { required: true, message: '', trigger: 'blur' }
        ],
        expiry_date_month:[
          { required: true, message: '', trigger: 'blur' }
        ],
        cvv:[
          { required: true, message: '', trigger: 'blur' }
        ],
      },
      month_options:[
        {label:'01',value:'01'},
        {label:'02',value:'02'},
        {label:'03',value:'03'},
        {label:'04',value:'04'},
        {label:'05',value:'05'},
        {label:'06',value:'06'},
        {label:'07',value:'07'},
        {label:'08',value:'08'},
        {label:'09',value:'09'},
        {label:'10',value:'10'},
        {label:'11',value:'11'},
        {label:'12',value:'12'},
      ],
      year_options:[],
    }
  },
  methods:{
    getYearsArray() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear + 20;
      const yearsArray = [];

      for (let year = startYear; year <= endYear; year++) {
        yearsArray.push(year);
      }

      // 转换成 [{ label: '2024', value: '2024' }] 这种格式
      const formattedYearsArray = yearsArray.map(year => ({
        label: year.toString(),
        value: year.toString()
      }));

      return formattedYearsArray;
    },
    validateCreditForm() {
      let flag = false
      this.$refs['creditForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    validateClear() {
      this.credit_form_data={
        card_holder_name:"",
        card_number:'',
        expiry_date_year:'',
        expiry_date_month:"",
        cvv:'',
      }
      this.$refs['creditForm'].resetFields()
    },
    blurCardNumHandle(e){
      if (this.credit_form_data.card_number.length<16){
        this.$message({
          type:"error",
          message:"Please enter a valid card number."
        })
      }
    },
    creditCvvHandle(){
      if (this.credit_form_data.cvv.length == 0){
        this.$message({
          type:"error",
          message:"Please enter a valid 3-digit CVV"
        })
      }
    }

  }
}
</script>

<style scoped lang="less">
.creditForm{
  margin-bottom: 48px;
  position: relative;

  .data_title{
    line-height: 32px;
    margin-right: 8px;
  }
  .card_img{
    position: absolute;
    top: 20px;
    right: 0;
    img {
      width: 24px;
      height: 16px;
      margin: 0 2px;
    }
  }

}
</style>
